import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_p959n8n2zn: FaireBrandEntity = {
  token: "b_p959n8n2zn",
  type: "brand",
  name: "Teigan & Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/01e205a519017df725c5cd9f9d1f0246a9b8479bcea936298dc5a4fe0d4e350a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/dfbaef46623c0d2d320439c4d7388ca4e4318c6301f6ffdff61ba07aeafa838f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/01e205a519017df725c5cd9f9d1f0246a9b8479bcea936298dc5a4fe0d4e350a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dfbaef46623c0d2d320439c4d7388ca4e4318c6301f6ffdff61ba07aeafa838f.jpeg",
  location: "Sumner, WA, USA",
  minimumOrderDollars: 50,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Teigan & Co. is a women’s and children’s boutique rooted in faith, family, and community. Named in honor of our angel Teigan, the brand was created to celebrate love, legacy, and the joy found in everyday moments.\nWe design and curate thoughtfully made apparel and accessories that balance comfort, quality, and everyday style—pieces that feel good, wear well, and sell well. Many of our collections are locally inspired and community-driven, making them easy additions for boutiques looking for meaningful, versatile styles their customers connect with.\nAt Teigan & Co., we believe great products tell a story—and the best ones keep customers coming back.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:18.635Z",
    importedBy: "entity-db-cli",
  },
};
